import { Box } from '@material-ui/core'
import { DropZoneArea } from 'shared/components/DropZoneArea/DropZoneArea'
import { HandlerOf } from 'shared/helpers/typeHelper'
import { errorD1 } from 'shared/theme/colors'
import { label4 } from 'shared/theme/typography'
import styled from 'styled-components'

interface UploadCDLProps {
  handleFrontFileChange?: HandlerOf<File | undefined> | ((file: File | undefined) => Promise<boolean>)
  handleBackFileChange?: HandlerOf<File | undefined> | ((file: File | undefined) => Promise<boolean>)
  showErrorMessage?: boolean
  uploadedFrontFile?: string
  uploadedBackFile?: string
  frontErrorMessage?: string
  backErrorMessage?: string
}

export const UploadCDL = ({
  handleFrontFileChange,
  handleBackFileChange,
  showErrorMessage = false,
  uploadedFrontFile,
  uploadedBackFile,
  frontErrorMessage,
  backErrorMessage,
}: UploadCDLProps) => {
  return (
    <Container>
      <div>
        <Label>Front side</Label>
        <DropZoneArea
          onChange={handleFrontFileChange}
          onDelete={() => handleFrontFileChange?.(undefined)}
          uploadedFile={uploadedFrontFile}
          error={frontErrorMessage}
        />
      </div>
      <div>
        <Box mt={2} />
        <Label>Back side</Label>
        <DropZoneArea
          onChange={handleBackFileChange}
          onDelete={() => handleBackFileChange?.(undefined)}
          uploadedFile={uploadedBackFile}
          error={backErrorMessage}
        />
      </div>
      {showErrorMessage && <ErrorMessage>Please upload both front and back images.</ErrorMessage>}
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  max-width: 500px;
  margin: 0 auto 50px auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  > div {
    width: 100%;
  }
`

const Label = styled.div`
  ${label4};
`

const ErrorMessage = styled.div`
  font-weight: 300;
  font-size: 14px;
  line-height: 21px;
  color: ${errorD1};
`
